(("function" != typeof lazySizes && "object" != typeof lazySizes) ||
  "undefined" == typeof lazySizes) &&
  ((function (t, e) {
    var i = (function (t, e) {
      "use strict";
      if (e.getElementsByClassName) {
        var i,
          s,
          a = e.documentElement,
          o = t.Date,
          l = t.HTMLPictureElement,
          r = "addEventListener",
          n = "getAttribute",
          c = t[r],
          p = t.setTimeout,
          d = t.requestAnimationFrame || p,
          f = t.requestIdleCallback,
          u = /^picture$/i,
          m = ["load", "error", "lazyincluded", "_lazyloaded"],
          g = {},
          b = Array.prototype.forEach,
          h = function (t, e) {
            return (
              g[e] || (g[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
              g[e].test(t[n]("class") || "") && g[e]
            );
          },
          y = function (t, e) {
            h(t, e) ||
              t.setAttribute("class", (t[n]("class") || "").trim() + " " + e);
          },
          v = function (t, e) {
            var i;
            (i = h(t, e)) &&
              t.setAttribute("class", (t[n]("class") || "").replace(i, " "));
          },
          w = function (t, e, i) {
            var s = i ? r : "removeEventListener";
            i && w(t, e),
              m.forEach(function (i) {
                t[s](i, e);
              });
          },
          T = function (t, s, a, o, l) {
            var r = e.createEvent("Event");
            return (
              a || (a = {}),
              (a.instance = i),
              r.initEvent(s, !o, !l),
              (r.detail = a),
              t.dispatchEvent(r),
              r
            );
          },
          _ = function (e, i) {
            var a;
            !l && (a = t.picturefill || s.pf)
              ? (i &&
                  i.src &&
                  !e[n]("srcset") &&
                  e.setAttribute("srcset", i.src),
                a({ reevaluate: !0, elements: [e] }))
              : i && i.src && (e.src = i.src);
          },
          P = function (t, e) {
            return (getComputedStyle(t, null) || {})[e];
          },
          C = function (t, e, i) {
            for (
              i = i || t.offsetWidth;
              i < s.minSize && e && !t._lazysizesWidth;

            )
              (i = e.offsetWidth), (e = e.parentNode);
            return i;
          },
          S = (function () {
            var t,
              i,
              s = [],
              a = [],
              o = s,
              l = function () {
                var e = o;
                for (o = s.length ? a : s, t = !0, i = !1; e.length; )
                  e.shift()();
                t = !1;
              },
              r = function (s, a) {
                t && !a
                  ? s.apply(this, arguments)
                  : (o.push(s), i || ((i = !0), (e.hidden ? p : d)(l)));
              };
            return (r._lsFlush = l), r;
          })(),
          j = function (t, e) {
            return e
              ? function () {
                  S(t);
                }
              : function () {
                  var e = this,
                    i = arguments;
                  S(function () {
                    t.apply(e, i);
                  });
                };
          },
          Q = function (t) {
            var e,
              i = 0,
              a = s.throttleDelay,
              l = s.ricTimeout,
              r = function () {
                (e = !1), (i = o.now()), t();
              },
              n =
                f && l > 49
                  ? function () {
                      f(r, { timeout: l }),
                        l !== s.ricTimeout && (l = s.ricTimeout);
                    }
                  : j(function () {
                      p(r);
                    }, !0);
            return function (t) {
              var s;
              (t = !0 === t) && (l = 33),
                e ||
                  ((e = !0),
                  (s = a - (o.now() - i)) < 0 && (s = 0),
                  t || s < 9 ? n() : p(n, s));
            };
          },
          z = function (t) {
            var e,
              i,
              s = function () {
                (e = null), t();
              },
              a = function () {
                var t = o.now() - i;
                t < 99 ? p(a, 99 - t) : (f || s)(s);
              };
            return function () {
              (i = o.now()), e || (e = p(a, 99));
            };
          };
        !(function () {
          var e,
            i = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((s = t.lazySizesConfig || t.lazysizesConfig || {}), i))
            e in s || (s[e] = i[e]);
          (t.lazySizesConfig = s),
            p(function () {
              s.init && k();
            });
        })();
        var F = (function () {
            var l,
              d,
              f,
              m,
              g,
              C,
              F,
              k,
              L,
              U,
              D,
              x,
              E = /^img$/i,
              I = /^iframe$/i,
              M = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
              H = 0,
              O = 0,
              N = -1,
              R = function (t) {
                O--, (!t || O < 0 || !t.target) && (O = 0);
              },
              B = function (t) {
                return (
                  null == x && (x = "hidden" == P(e.body, "visibility")),
                  x ||
                    ("hidden" != P(t.parentNode, "visibility") &&
                      "hidden" != P(t, "visibility"))
                );
              },
              q = function (t, i) {
                var s,
                  o = t,
                  l = B(t);
                for (
                  k -= i, D += i, L -= i, U += i;
                  l && (o = o.offsetParent) && o != e.body && o != a;

                )
                  (l = (P(o, "opacity") || 1) > 0) &&
                    "visible" != P(o, "overflow") &&
                    ((s = o.getBoundingClientRect()),
                    (l =
                      U > s.left &&
                      L < s.right &&
                      D > s.top - 1 &&
                      k < s.bottom + 1));
                return l;
              },
              G = function () {
                var t,
                  o,
                  r,
                  c,
                  p,
                  f,
                  u,
                  g,
                  b,
                  h,
                  y,
                  v,
                  w = i.elements;
                if ((m = s.loadMode) && O < 8 && (t = w.length)) {
                  for (o = 0, N++; o < t; o++)
                    if (w[o] && !w[o]._lazyRace)
                      if (!M || (i.prematureUnveil && i.prematureUnveil(w[o])))
                        Y(w[o]);
                      else if (
                        (((g = w[o][n]("data-expand")) && (f = 1 * g)) ||
                          (f = H),
                        h ||
                          ((h =
                            !s.expand || s.expand < 1
                              ? a.clientHeight > 500 && a.clientWidth > 500
                                ? 500
                                : 370
                              : s.expand),
                          (i._defEx = h),
                          (y = h * s.expFactor),
                          (v = s.hFac),
                          (x = null),
                          H < y && O < 1 && N > 2 && m > 2 && !e.hidden
                            ? ((H = y), (N = 0))
                            : (H = m > 1 && N > 1 && O < 6 ? h : 0)),
                        b !== f &&
                          ((C = innerWidth + f * v),
                          (F = innerHeight + f),
                          (u = -1 * f),
                          (b = f)),
                        (r = w[o].getBoundingClientRect()),
                        (D = r.bottom) >= u &&
                          (k = r.top) <= F &&
                          (U = r.right) >= u * v &&
                          (L = r.left) <= C &&
                          (D || U || L || k) &&
                          (s.loadHidden || B(w[o])) &&
                          ((d && O < 3 && !g && (m < 3 || N < 4)) ||
                            q(w[o], f)))
                      ) {
                        if ((Y(w[o]), (p = !0), O > 9)) break;
                      } else
                        !p &&
                          d &&
                          !c &&
                          O < 4 &&
                          N < 4 &&
                          m > 2 &&
                          (l[0] || s.preloadAfterLoad) &&
                          (l[0] ||
                            (!g &&
                              (D ||
                                U ||
                                L ||
                                k ||
                                "auto" != w[o][n](s.sizesAttr)))) &&
                          (c = l[0] || w[o]);
                  c && !p && Y(c);
                }
              },
              V = Q(G),
              W = function (t) {
                var e = t.target;
                e._lazyCache
                  ? delete e._lazyCache
                  : (R(t),
                    y(e, s.loadedClass),
                    v(e, s.loadingClass),
                    w(e, X),
                    T(e, "lazyloaded"));
              },
              $ = j(W),
              X = function (t) {
                $({ target: t.target });
              },
              J = function (t) {
                var e,
                  i = t[n](s.srcsetAttr);
                (e = s.customMedia[t[n]("data-media") || t[n]("media")]) &&
                  t.setAttribute("media", e),
                  i && t.setAttribute("srcset", i);
              },
              K = j(function (t, e, i, a, o) {
                var l, r, c, d, m, g;
                (m = T(t, "lazybeforeunveil", e)).defaultPrevented ||
                  (a &&
                    (i ? y(t, s.autosizesClass) : t.setAttribute("sizes", a)),
                  (r = t[n](s.srcsetAttr)),
                  (l = t[n](s.srcAttr)),
                  o && (d = (c = t.parentNode) && u.test(c.nodeName || "")),
                  (g = e.firesLoad || ("src" in t && (r || l || d))),
                  (m = { target: t }),
                  y(t, s.loadingClass),
                  g && (clearTimeout(f), (f = p(R, 2500)), w(t, X, !0)),
                  d && b.call(c.getElementsByTagName("source"), J),
                  r
                    ? t.setAttribute("srcset", r)
                    : l &&
                      !d &&
                      (I.test(t.nodeName)
                        ? (function (t, e) {
                            try {
                              t.contentWindow.location.replace(e);
                            } catch (i) {
                              t.src = e;
                            }
                          })(t, l)
                        : (t.src = l)),
                  o && (r || d) && _(t, { src: l })),
                  t._lazyRace && delete t._lazyRace,
                  v(t, s.lazyClass),
                  S(function () {
                    var e = t.complete && t.naturalWidth > 1;
                    (g && !e) ||
                      (e && y(t, "ls-is-cached"),
                      W(m),
                      (t._lazyCache = !0),
                      p(function () {
                        "_lazyCache" in t && delete t._lazyCache;
                      }, 9)),
                      "lazy" == t.loading && O--;
                  }, !0);
              }),
              Y = function (t) {
                if (!t._lazyRace) {
                  var e,
                    i = E.test(t.nodeName),
                    a = i && (t[n](s.sizesAttr) || t[n]("sizes")),
                    o = "auto" == a;
                  ((!o && d) ||
                    !i ||
                    (!t[n]("src") && !t.srcset) ||
                    t.complete ||
                    h(t, s.errorClass) ||
                    !h(t, s.lazyClass)) &&
                    ((e = T(t, "lazyunveilread").detail),
                    o && A.updateElem(t, !0, t.offsetWidth),
                    (t._lazyRace = !0),
                    O++,
                    K(t, e, o, a, i));
                }
              },
              Z = z(function () {
                (s.loadMode = 3), V();
              }),
              tt = function () {
                3 == s.loadMode && (s.loadMode = 2), Z();
              },
              et = function () {
                if (!d) {
                  if (o.now() - g < 999) return void p(et, 999);
                  (d = !0), (s.loadMode = 3), V(), c("scroll", tt, !0);
                }
              };
            return {
              _: function () {
                (g = o.now()),
                  (i.elements = e.getElementsByClassName(s.lazyClass)),
                  (l = e.getElementsByClassName(
                    s.lazyClass + " " + s.preloadClass
                  )),
                  c("scroll", V, !0),
                  c("resize", V, !0),
                  t.MutationObserver
                    ? new MutationObserver(V).observe(a, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      })
                    : (a[r]("DOMNodeInserted", V, !0),
                      a[r]("DOMAttrModified", V, !0),
                      setInterval(V, 999)),
                  c("hashchange", V, !0),
                  [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend",
                    "webkitAnimationEnd",
                  ].forEach(function (t) {
                    e[r](t, V, !0);
                  }),
                  /d$|^c/.test(e.readyState)
                    ? et()
                    : (c("load", et), e[r]("DOMContentLoaded", V), p(et, 2e4)),
                  i.elements.length ? (G(), S._lsFlush()) : V();
              },
              checkElems: V,
              unveil: Y,
              _aLSL: tt,
            };
          })(),
          A = (function () {
            var t,
              i = j(function (t, e, i, s) {
                var a, o, l;
                if (
                  ((t._lazysizesWidth = s),
                  (s += "px"),
                  t.setAttribute("sizes", s),
                  u.test(e.nodeName || ""))
                )
                  for (
                    o = 0, l = (a = e.getElementsByTagName("source")).length;
                    o < l;
                    o++
                  )
                    a[o].setAttribute("sizes", s);
                i.detail.dataAttr || _(t, i.detail);
              }),
              a = function (t, e, s) {
                var a,
                  o = t.parentNode;
                o &&
                  ((s = C(t, o, s)),
                  (a = T(t, "lazybeforesizes", { width: s, dataAttr: !!e }))
                    .defaultPrevented ||
                    ((s = a.detail.width) &&
                      s !== t._lazysizesWidth &&
                      i(t, o, a, s)));
              },
              o = z(function () {
                var e,
                  i = t.length;
                if (i) for (e = 0; e < i; e++) a(t[e]);
              });
            return {
              _: function () {
                (t = e.getElementsByClassName(s.autosizesClass)),
                  c("resize", o);
              },
              checkElems: o,
              updateElem: a,
            };
          })(),
          k = function () {
            k.i || ((k.i = !0), A._(), F._());
          };
        return (i = {
          cfg: s,
          autoSizer: A,
          loader: F,
          init: k,
          uP: _,
          aC: y,
          rC: v,
          hC: h,
          fire: T,
          gW: C,
          rAF: S,
        });
      }
    })(t, t.document);
    (t.lazySizes = i),
      "object" == typeof module && module.exports && (module.exports = i);
  })(window),
  (function (t, e) {
    var i = function () {
      e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i) {
    "use strict";
    function s(e, i) {
      var s,
        a,
        o,
        l,
        r = t.getComputedStyle(e);
      for (s in ((a = e.parentNode),
      (l = { isPicture: !(!a || !d.test(a.nodeName || "")) }),
      (o = function (t, i) {
        var s = e.getAttribute("data-" + t);
        if (!s) {
          var a = r.getPropertyValue("--ls-" + t);
          a && (s = a.trim());
        }
        if (s) {
          if ("true" == s) s = !0;
          else if ("false" == s) s = !1;
          else if (p.test(s)) s = parseFloat(s);
          else if ("function" == typeof n[t]) s = n[t](e, s);
          else if (g.test(s))
            try {
              s = JSON.parse(s);
            } catch (t) {}
          l[t] = s;
        } else
          t in n && "function" != typeof n[t]
            ? (l[t] = n[t])
            : i && "function" == typeof n[t] && (l[t] = n[t](e, s));
      }),
      n))
        o(s);
      return (
        i.replace(m, function (t, e) {
          e in l || o(e, !0);
        }),
        l
      );
    }
    function a(t, i, s) {
      var a = 0,
        o = 0,
        l = s;
      if (t) {
        if ("container" === i.ratio) {
          for (a = l.scrollWidth, o = l.scrollHeight; !((a && o) || l === e); )
            (a = (l = l.parentNode).scrollWidth), (o = l.scrollHeight);
          a && o && (i.ratio = o / a);
        }
        ((t = (function (t, e) {
          var i = [];
          return (
            (i.srcset = []),
            e.absUrl && (h.setAttribute("href", t), (t = h.href)),
            (t = ((e.prefix || "") + t + (e.postfix || "")).replace(
              m,
              function (t, i) {
                return c[typeof e[i]] ? e[i] : t;
              }
            )),
            e.widths.forEach(function (s) {
              var a = e.widthmap[s] || s,
                o = e.aspectratio || e.ratio,
                l = !e.aspectratio && n.traditionalRatio,
                r = {
                  u: t
                    .replace(f, a)
                    .replace(
                      u,
                      o ? (l ? Math.round(s * o) : Math.round(s / o)) : ""
                    ),
                  w: s,
                };
              i.push(r), i.srcset.push((r.c = r.u + " " + s + "w"));
            }),
            i
          );
        })(t, i)).isPicture = i.isPicture),
          v && "IMG" == s.nodeName.toUpperCase()
            ? s.removeAttribute(r.srcsetAttr)
            : s.setAttribute(r.srcsetAttr, t.srcset.join(", ")),
          Object.defineProperty(s, "_lazyrias", { value: t, writable: !0 });
      }
    }
    function o(t, e) {
      var a = s(t, e);
      return (
        n.modifyOptions.call(t, { target: t, details: a, detail: a }),
        i.fire(t, "lazyriasmodifyoptions", a),
        a
      );
    }
    function l(t) {
      return (
        t.getAttribute(t.getAttribute("data-srcattr") || n.srcAttr) ||
        t.getAttribute(r.srcsetAttr) ||
        t.getAttribute(r.srcAttr) ||
        t.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    var r,
      n,
      c = { string: 1, number: 1 },
      p = /^\-*\+*\d+\.*\d*$/,
      d = /^picture$/i,
      f = /\s*\{\s*width\s*\}\s*/i,
      u = /\s*\{\s*height\s*\}\s*/i,
      m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      g = /^\[.*\]|\{.*\}$/,
      b = /^(?:auto|\d+(px)?)$/,
      h = e.createElement("a"),
      y = e.createElement("img"),
      v = "srcset" in y && !("sizes" in y),
      w = !!t.HTMLPictureElement && !v;
    !(function () {
      var e,
        s = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: function () {},
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      for (e in ((r = (i && i.cfg) || t.lazySizesConfig) ||
        ((r = {}), (t.lazySizesConfig = r)),
      r.supportsType ||
        (r.supportsType = function (t) {
          return !t;
        }),
      r.rias || (r.rias = {}),
      "widths" in (n = r.rias) ||
        ((n.widths = []),
        (function (t) {
          for (var e, i = 0; !e || e < 3e3; )
            (i += 5) > 30 && (i += 1), (e = 36 * i), t.push(e);
        })(n.widths)),
      s))
        e in n || (n[e] = s[e]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (t) {
          var e, s, c, p, d, u, m, g, h, y, v, _, P;
          if (
            t.detail.instance == i &&
            ((e = t.target),
            t.detail.dataAttr &&
              !t.defaultPrevented &&
              !n.disabled &&
              (h = e.getAttribute(r.sizesAttr) || e.getAttribute("sizes")) &&
              b.test(h))
          ) {
            if (
              ((c = o(e, (s = l(e)))),
              (v = f.test(c.prefix) || f.test(c.postfix)),
              c.isPicture && (p = e.parentNode))
            )
              for (
                u = 0, m = (d = p.getElementsByTagName("source")).length;
                u < m;
                u++
              )
                (v || f.test((g = l(d[u])))) && (a(g, c, d[u]), (_ = !0));
            v || f.test(s)
              ? (a(s, c, e), (_ = !0))
              : _ &&
                (((P = []).srcset = []),
                (P.isPicture = !0),
                Object.defineProperty(e, "_lazyrias", {
                  value: P,
                  writable: !0,
                })),
              _ &&
                (w
                  ? e.removeAttribute(r.srcAttr)
                  : "auto" != h &&
                    ((y = { width: parseInt(h, 10) }),
                    T({ target: e, detail: y })));
          }
        },
        !0
      );
    var T = (function () {
      var s = function (t, e) {
          return t.w - e.w;
        },
        a = function (t, e) {
          var s;
          return (
            !t._lazyrias &&
              i.pWS &&
              (s = i.pWS(t.getAttribute(r.srcsetAttr || ""))).length &&
              (Object.defineProperty(t, "_lazyrias", {
                value: s,
                writable: !0,
              }),
              e &&
                t.parentNode &&
                (s.isPicture =
                  "PICTURE" == t.parentNode.nodeName.toUpperCase())),
            t._lazyrias
          );
        },
        o = function (e) {
          var s = t.devicePixelRatio || 1,
            a = i.getX && i.getX(e);
          return Math.min(a || s, 2.4, s);
        },
        l = function (e, i) {
          var l, r, n, c, p, d;
          if ((p = e._lazyrias).isPicture && t.matchMedia)
            for (
              r = 0,
                n = (l = e.parentNode.getElementsByTagName("source")).length;
              r < n;
              r++
            )
              if (
                a(l[r]) &&
                !l[r].getAttribute("type") &&
                (!(c = l[r].getAttribute("media")) ||
                  (matchMedia(c) || {}).matches)
              ) {
                p = l[r]._lazyrias;
                break;
              }
          return (
            (!p.w || p.w < i) &&
              ((p.w = i),
              (p.d = o(e)),
              (d = (function (t) {
                for (var e, i, s = t.length, a = t[s - 1], o = 0; o < s; o++)
                  if ((((a = t[o]).d = a.w / t.w), a.d >= t.d)) {
                    !a.cached &&
                      (e = t[o - 1]) &&
                      e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                      ((i = Math.pow(e.d - 0.6, 1.6)),
                      e.cached && (e.d += 0.15 * i),
                      e.d + (a.d - t.d) * i > t.d && (a = e));
                    break;
                  }
                return a;
              })(p.sort(s)))),
            d
          );
        },
        n = function (s) {
          if (s.detail.instance == i) {
            var o,
              c = s.target;
            if (!v && (t.respimage || t.picturefill || lazySizesConfig.pf))
              return void e.removeEventListener("lazybeforesizes", n);
            ("_lazyrias" in c || (s.detail.dataAttr && a(c, !0))) &&
              (o = l(c, s.detail.width)) &&
              o.u &&
              c._lazyrias.cur != o.u &&
              ((c._lazyrias.cur = o.u),
              (o.cached = !0),
              i.rAF(function () {
                c.setAttribute(r.srcAttr, o.u), c.setAttribute("src", o.u);
              }));
          }
        };
      return (
        w ? (n = function () {}) : addEventListener("lazybeforesizes", n), n
      );
    })();
  })),
  "undefined" != typeof theme &&
    theme.hasOwnProperty("settings") &&
    (theme.settings.predictiveSearchEnabled = !1);
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    loadProductFirst: !1,
    showPlaceholderProductList: !0,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass:
      "boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2",
    enableOTP: !0,
    aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
    defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
    selectOptionContainer: ".boost-pfs-filter-product-item-image",
  },
  selector: { otpButtons: ".boost-pfs-filter-product-item-image" },
};
!(function () {
  var t = !1,
    e = !1,
    i = [],
    s = [1400, 1500, 2200, 3e3];
  function a(s) {
    if (
      ((e = !s.available),
      (t = s.compare_at_price_min > s.price_min),
      s.price_min,
      s.price_max,
      (i = s.images_info),
      s.variants[0],
      null !== Utils.getParam("variant") && "" != Utils.getParam("variant"))
    ) {
      var a = s.variants.filter(function (t) {
        return t.id == Utils.getParam("variant");
      });
      void 0 !== a[0] && a[0];
    } else
      for (var o = 0; o < s.variants.length; o++)
        if (s.variants[o].available) {
          s.variants[o];
          break;
        }
    return s;
  }
  function o(t) {
    for (
      var e = "",
        a = s,
        o =
          (t.title,
          !Utils.isMobile() &&
            i.length > 1 &&
            boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
            1 == boostPFSThemeConfig.custom.active_image_swap),
        l = 0;
      l < a.length;
      l++
    )
      Utils.getFeaturedImage(i, a[l] + "x"),
        o && Utils.optimizeImage(i[1].src, a[l] + "x");
    i.length > 0 && (i[0].width, i[0].height);
    const r = t.media;

    // new arrival tag
    var new_tag = "";
    for (const key of t.collections) {
      if (key.handle == "new-arrivals") {
        new_tag = "New Arrival";
      }
    }

    // check if product has more than 2 slides
    // var slideshow = false;
    // r.forEach(function (i, s) {
    //     if (s > 2) {
    //         slideshow = true;
    //     }
    // })

    var slideshow = false;

    return (
      (e += '<div class="product-item-slider">'),
      (e += '<div class="swiper-wrapper">'),
      r.forEach(function (i, s) {
        s === 1 &&
          ((e += '<div class="swiper-slide">'),
          "VIDEO" == i.mediaContentType
            ? (e +=
                '<div class="video-wrapper"><video autoplay="" loop="" muted="" playsinline="" loading="lazy" class="media-video"><source type="video/mp4" class="media-object" data-type="video" src="' +
                i.sources[0].url +
                '"></video></div>')
            : "EXTERNAL_VIDEO" == i.mediaContentType ||
              ((e +=
                '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link">'),
              (e +=
                '<img class="boost-pfs-filter-product-item-main-image" alt="{{itemTitle}}" data-second="' +
                (r[2]
                  ? r[2].image.originalSrc + "&width=800"
                  : r[1].image.originalSrc + "&width=800") +
                '" src="' +
                i.image.originalSrc +
                "&width=800" +
                '" data-og="' +
                i.image.originalSrc +
                '" />'),
              (e += "</a>")),
          (e += "</div>"));
      }),
      (e += "</div>"),
      slideshow == true
        ? (e +=
            '<button class="product-item-slider-nav-btn" data-component="product-item-slider-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></button>')
        : (e +=
            '<button style="visibility: hidden; pointer-events: none;" class="product-item-slider-nav-btn" data-component="product-item-slider-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></button>'),
      slideshow == true
        ? (e +=
            '<button class="product-item-slider-nav-btn" data-component="product-item-slider-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></button>')
        : (e +=
            '<button style="visibility: hidden; pointer-events: none;" class="product-item-slider-nav-btn" data-component="product-item-slider-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></button>'),
      new_tag != ""
        ? (e += '<span class="product-item-tag">' + new_tag + "</span>")
        : (e += "")
    );
  }
  function l(e) {
    const showPrice = boostPFSThemeConfig.custom.hasOwnProperty('show_price') && boostPFSThemeConfig.custom.show_price;
    if (!showPrice) return '';

    const sizeSelectorMf = e.metafields.find((m) => m.key === 'size_selector');
    const isSizeSelectorEnabled = sizeSelectorMf?.value === 'true' && e.variants.length > 1;
    const ooakMf = e.metafields.find((m) => m.key === 'ooak');
    const isOoak = ooakMf?.value === 'true';
    const THRESHOLD_CENTS = 250000; // $$250,000
    const meetThreshold = e.price_min >= THRESHOLD_CENTS;
    const hasNoInventory = e.variants.every((v) => v.inventory_quantity === 0);

    const isInquire = (() => {
      if (isSizeSelectorEnabled) return false;
      if (meetThreshold) return true;
      if (isOoak && hasNoInventory) return true;
      return false;
    })();

    if (isInquire) {
      return `
        <p class="boost-pfs-filter-product-item-price">
          <span class="boost-pfs-filter-product-item-regular-price">INQUIRE</span>
        </p>
      `;
    }

    const priceMinStr = Utils.formatMoney(e.price_min);
    const compareAtPriceMinStr = Utils.formatMoney(e.compare_at_price_min);

    return `
      <p class="boost-pfs-filter-product-item-price">
        ${
          t
            ? `<span class="boost-pfs-filter-product-item-sale-price">${priceMinStr}</span><s>${compareAtPriceMinStr}</s>`
            : `<span class="boost-pfs-filter-product-item-regular-price">${priceMinStr}</span>`
        }
      </p>
    `;
  }
  function r(i) {
    var s = "";
    boostPFSThemeConfig.custom.hasOwnProperty("sold_out_enable") &&
      boostPFSThemeConfig.custom.sold_out_enable &&
      e &&
      (s = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, ""));
    var a = "",
      o = "";
    return (
      boostPFSThemeConfig.custom.sale_label_enable &&
        t &&
        !e &&
        ("sale_percent" == boostPFSThemeConfig.custom.sale_label_display &&
          (o = Math.round(
            (100 * (i.compare_at_price_min - i.price_min)) /
              i.compare_at_price_max
          )),
        (a = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, "")),
        (a = boostPFSTemplate.saleLabelHtml.replace(
          /percent/g,
          "-" + o + "%"
        ))),
      s + a
    );
  }
  function n(t, e) {
    if (boostPFSThemeConfig.custom.tag_label_enable) {
      if (e) {
        var i = "";
        if (t.tags)
          for (var s = 0; s < t.tags.length; s++) {
            var a = t.tags[s];
            -1 !== a.indexOf("pfs:label") &&
              (i += boostPFSTemplate.tagLabelHtml.replace(
                /{{labelTag}}/g,
                a.split("pfs:label-")[1]
              ));
          }
      } else if (((i = ""), t.tags))
        for (s = t.tags.length - 1; s >= 0; s--)
          if (-1 !== (a = t.tags[s]).indexOf("pfs:label")) {
            i += boostPFSTemplate.tagLabelHtml.replace(
              /{{labelTag}}/g,
              a.split("pfs:label-")[1]
            );
            break;
          }
      return i;
    }
    return "";
  }
  function c(t, e, i) {
    return i.indexOf(t) === e;
  }
  function p(t) {
    var e = "";
    if (boostPFSThemeConfig.custom.swatch_enable)
      for (
        var i = ["color", "img", "pro_img", "text"], s = 0;
        s < i.length;
        s++
      )
        for (
          var a = boostPFSThemeConfig.custom["swatch_by_" + i[s] + "_apply"]
              .split(",")
              .filter(c),
            o = boostPFSThemeConfig.custom["swatch_by_" + i[s] + "_shape"],
            l = i[s],
            r = 0;
          r < a.length;
          r++
        ) {
          var n = a[r].trim(),
            p = n,
            d = [],
            f = 0,
            u = [],
            m = 4,
            g = Utils.getFeaturedImage(t.images_info, "360x"),
            b = "#ffffff",
            h = "",
            y = "More " + p;
          if (
            void 0 !== t.options_with_values &&
            t.options_with_values.length > 0 &&
            (d = t.options_with_values.filter(function (t) {
              return t.name == n;
            })).length > 0
          ) {
            m > (f = d[0].values.length) && (m = f),
              (u = d[0].values),
              (e +=
                '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option' +
                n +
                " boost-pfs-filter-item-swatch-shape-" +
                o +
                " boost-pfs-filter-item-swatch-type-" +
                l +
                '">');
            for (var v = 0; v < m; v++) {
              if (
                ((b = u[v].title),
                (swatchVariant = t.variants[v]),
                (sImageIndex = u[v].image || ""),
                "" != sImageIndex &&
                  (g =
                    Utils.optimizeImage(swatchVariant.image, "360x") + " 360w"),
                l)
              )
                switch (l) {
                  case "img":
                    h = boostPFSAppConfig.general.file_url.replace(
                      /\?/,
                      Utils.slugify(p).replace(/\-/g, "_") +
                        "-" +
                        Utils.slugify(b) +
                        ".png?v="
                    );
                    break;
                  case "pro_img":
                    (h = Utils.getFeaturedImage(t.images_info, "50x")),
                      "" != sImageIndex &&
                        (h = Utils.optimizeImage(t.images[sImageIndex], "50x")),
                      h && h.includes("boost-pfs-no-image") && (h = "");
                    break;
                  default:
                    h = "";
                }
              (e += "<li>"),
                "text" == l
                  ? (e +=
                      '<a aria-label="' +
                      n +
                      ": " +
                      b +
                      '" title="' +
                      b +
                      '" href="' +
                      Utils.buildProductItemUrl(t) +
                      "?variant=" +
                      swatchVariant.id +
                      '">' +
                      b +
                      "</a>")
                  : (boostPFSThemeConfig.custom.show_swatch_tooltip &&
                      (e +=
                        '<div class="boost-pfs-product-item-tooltip">' +
                        b +
                        "</div>"),
                    (e +=
                      '<span tabindex="0" aria-label="' +
                      n +
                      ": " +
                      b +
                      '" style="background-color: ' +
                      b +
                      "; "),
                    (e +=
                      "" != h ? "background-image: url(" + h + ');" ' : '" '),
                    "" != g && (e += 'data-img="' + g + '" '),
                    (e += "></span>")),
                (e += "</li>");
            }
            f > m &&
              ((e += '<li class="boost-pfs-filter-item-swatch-more">'),
              (e +=
                '<a href="{{itemUrl}}" aria-label="' +
                y +
                '" title="' +
                y +
                '">+' +
                (f - m) +
                "</a>"),
              (e += "</li>")),
              (e += "</ul>");
          }
        }
    return e;
  }
  function d(t) {
    return !Utils.isMobile() &&
      i.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
      1 == boostPFSThemeConfig.custom.active_image_swap
      ? "has-bc-swap-image"
      : "";
  }
  function f(t, e) {
    return "" === t
      ? t
      : "list" === t
      ? Labels.listView || "List view"
      : void 0 === e || 0 === e
      ? Labels.gridView || "Grid view"
      : (Labels.gridViewColumns || "Grid view {{ count }} Columns").replace(
          /{{ count }}/g,
          e
        );
  }
  BoostPFS.inject(this),
    (boostPFSFilterConfig.general.separateRefineByFromFilter = !!(
      jQ(".boost-pfs-filter-tree-h").length &&
      !Utils.isMobile() > 0 &&
      "style-expand" != boostPFSThemeConfig.custom.filter_tree_horizontal_style
    )),
    (Selector.stickyElementDesktop =
      jQ(".boost-pfs-filter-left-col").length > 0 && !Utils.isMobile()
        ? ".boost-pfs-filter-left-col"
        : ".boost-pfs-filter-tree"),
    (ProductGridItem.prototype.compileTemplate = function (i) {
      i || (i = this.data), (i = a(i));
      var s,
        c = boostPFSTemplate.productGridItemHtml,
        f = e ? boostPFSTemplate.soldOutClass : "",
        u = t ? boostPFSTemplate.saleClass : "";
      return (
        (c = (c = (c = (c = (c = (c = (c = c.replace(
          /{{soldOutClass}}/g,
          f
        )).replace(/{{saleClass}}/g, u)).replace(
          /{{gridWidthClass}}/g,
          (function () {
            var t = "";
            switch (boostPFSThemeConfig.custom.products_per_row) {
              case 2:
                t = "boost-pfs-filter-grid-width-2";
                break;
              case 3:
                t = "boost-pfs-filter-grid-width-3";
                break;
              case 5:
                t = "boost-pfs-filter-grid-width-5";
                break;
              case 6:
                t = "boost-pfs-filter-grid-width-6";
                break;
              default:
                t = "boost-pfs-filter-grid-width-4";
            }
            switch (boostPFSThemeConfig.custom.products_per_row_m) {
              case 1:
                t += " boost-pfs-filter-grid-width-mb-1";
                break;
              case 3:
                t += " boost-pfs-filter-grid-width-mb-3";
                break;
              default:
                t += " boost-pfs-filter-grid-width-mb-2";
            }
            return t;
          })()
        )).replace(/{{itemLabels}}/g, r(i))).replace(
          /{{itemTagLabels}}/g,
          n(i, !1)
        )).replace(/{{itemImages}}/g, o(i))).replace(/{{itemPrice}}/g, l(i))),
        ("undefined" == typeof Integration ||
          ("undefined" != typeof Integration &&
            "function" == typeof Integration.hascompileTemplate &&
            !Integration.hascompileTemplate("reviews"))) &&
          (c = c.replace(
            /{{itemReviews}}/g,
            ((s = ""),
            boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
              1 == boostPFSThemeConfig.custom.show_product_review &&
              (s =
                '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'),
            s)
          )),
        (c = (c = (c = (c = (c = (c = (c = c.replace(
          /{{itemVendor}}/g,
          (function (t) {
            var e = "";
            return (
              boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
                1 == boostPFSThemeConfig.custom.show_vendor &&
                (e = boostPFSTemplate.vendorHtml),
              e
            );
          })()
        )).replace(/{{itemActiveSwapClass}}/g, d())).replace(
          /{{itemSwatches}}/g,
          p(i)
        )).replace(/{{itemId}}/g, i.id)).replace(
          /{{itemTitle}}/g,
          i.title
        )).replace(/{{itemHandle}}/g, i.handle)).replace(
          /{{itemVendorLabel}}/g,
          i.vendor
        )).replace(/{{itemVariantTitle}}/g, i.metafields.find(metafield => metafield.key === "plp_product_details")?.value || ""
        )).replace(
          /{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(i)
      );
    }),
    (ProductListItem.prototype.compileTemplate = function (i) {
      i || (i = this.data), (i = a(i));
      var s = boostPFSTemplate.productListItemHtml,
        c = e ? boostPFSTemplate.soldOutClass : "",
        f = t ? boostPFSTemplate.saleClass : "";
      s = (s = (s = (s = (s = s.replace(/{{soldOutClass}}/g, c)).replace(
        /{{saleClass}}/g,
        f
      )).replace(/{{itemLabels}}/g, r(i))).replace(
        /{{itemTagLabels}}/g,
        n(i, !1)
      )).replace(/{{itemImages}}/g, o(i));
      var u = l(i);
      return (s = (s = (s = (s = (s = (s = s.replace(
        /{{itemPrice}}/g,
        u
      )).replace(/{{itemActiveSwapClass}}/g, d())).replace(
        /{{itemSwatches}}/g,
        p(i)
      )).replace(/{{itemTitle}}/g, i.title)).replace(
        /{{itemVendorLabel}}/g,
        i.vendor
      )).replace(
        /{{itemUrl}}/g,
        Utils.buildProductItemUrlWithVariant(i)
      )).replace(/{{itemId}}/g, i.id);
    }),
    (ProductPaginationDefault.prototype.compileTemplate = function (t) {
      t || (t = this.totalProduct);
      var e = parseInt(Utils.stripHtml(Globals.queryParams.page)),
        i = Math.ceil(t / Utils.stripHtml(Globals.queryParams.limit));
      if (((e && !isNaN(e)) || (e = 1), i <= 1)) return "";
      var s = boostPFSTemplate.paginateHtml,
        a =
          e > 1
            ? boostPFSTemplate.previousActiveHtml
            : boostPFSTemplate.previousDisabledHtml;
      (a = a.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e - 1))),
        (s = s.replace(/{{previous}}/g, a));
      var o =
        e < i
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      (o = o.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", e, e + 1))),
        (s = s.replace(/{{next}}/g, o));
      for (var l = [], r = e - 1; r > e - 3 && r > 0; r--) l.unshift(r);
      e - 4 > 0 && l.unshift("..."), e - 4 >= 0 && l.unshift(1), l.push(e);
      for (var n = [], c = e + 1; c < e + 3 && c <= i; c++) n.push(c);
      e + 3 < i && n.push("..."), e + 3 <= i && n.push(i);
      for (var p = "", d = (l.concat(n), 0); d < 1; d++)
        p +=
          '<li class="pagination__item pagination_number">' +
          e +
          " / " +
          i +
          "</li>";
      return s.replace(/{{pageItems}}/g, p);
    }),
    (ProductSorting.prototype.compileTemplate = function () {
      var t = boostPFSTemplate.sortingHtml;
      if (
        boostPFSThemeConfig.custom.show_sort_by &&
        boostPFSTemplate.hasOwnProperty("sortingHtml")
      ) {
        var e = Utils.getSortingList();
        if (e) {
          var i = Utils.stripHtml(Globals.queryParams.sort) || "",
            s = "";
          for (var a in e)
            (activeClass = ""),
              i == a && (activeClass = "boost-pfs-filter-sort-item-active"),
              (s +=
                '<li aria-label="' +
                e[a] +
                '"><a href="#" data-sort="' +
                a +
                '" class="' +
                activeClass +
                '"  title="' +
                e[a] +
                '" aria-label="' +
                e[a] +
                '">' +
                e[a] +
                "</a></li>");
          t = (t = t.replace(/{{sortingItems}}/g, s)).replace(
            /{{sortingLabel}}/g,
            Labels.sorting
          );
        }
      }
      return t;
    }),
    (ProductSorting.prototype.render = function () {
      jQ(Selector.topSorting).html(this.compileTemplate()),
        jQ(".boost-pfs-filter-custom-sorting").hasClass(
          "boost-pfs-filter-sort-active"
        ) &&
          jQ(".boost-pfs-filter-custom-sorting").toggleClass(
            "boost-pfs-filter-sort-active"
          );
      var t,
        e = Utils.stripHtml(Globals.queryParams.sort) || "",
        i = Utils.getSortingList();
      (t = e.length > 0 && i && i[e] ? i[e] : Labels.sorting_heading),
        jQ(".boost-pfs-filter-custom-sorting button span span").text(t);
    }),
    (ProductSorting.prototype.bindEvents = function () {
      jQ(".boost-pfs-filter-filter-dropdown a").click(function (t) {
        t.preventDefault(),
          FilterApi.setParam("sort", jQ(this).data("sort")),
          FilterApi.setParam("page", 1),
          FilterApi.applyFilter("sort");
      }),
        jQ(".boost-pfs-filter-custom-sorting > button").click(function () {
          jQ(".boost-pfs-filter-filter-dropdown")
            .toggle()
            .parent()
            .toggleClass("boost-pfs-filter-sort-active");
        }),
        jQ(Selector.filterTreeMobileButton).click(function () {
          jQ(
            ".boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown"
          ).hide();
        }),
        jQ(document).on("click", function (t) {
          0 ===
            jQ(t.target)
              .parents(".boost-pfs-filter-top-sorting")
              .find(".boost-pfs-filter-filter-dropdown").length &&
            jQ(".boost-pfs-filter-filter-dropdown")
              .hide()
              .parent()
              .removeClass("boost-pfs-filter-sort-active");
        });
    }),
    (ProductDisplayType.prototype.compileTemplate = function () {
      var t = "<span>" + boostPFSThemeConfig.label.toolbar_viewas + "</span>";
      return (
        "grid" == boostPFSThemeConfig.custom.product_item_type
          ? "view_as_type_list_grid_multi_col" !=
              boostPFSThemeConfig.custom.view_as_type || Utils.isMobile()
            ? ((t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "grid", "list") +
                '" title="' +
                f("list") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'))
            : ((t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "grid", "list") +
                '" title="' +
                f("list") +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid", 2) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid", 3) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text">3</span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid", 4) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid", 5) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>'),
              (t +=
                '<a href="' +
                Utils.buildToolbarLink("display", "list", "grid") +
                '" title="' +
                f("grid", 6) +
                '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text">6</span></a>'))
          : "view_as_type_list_grid_multi_col" !=
              boostPFSThemeConfig.custom.view_as_type || Utils.isMobile()
          ? ((t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "grid", "list") +
              '" title="' +
              f("list") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'))
          : ((t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "grid", "list") +
              '" title="' +
              f("list") +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid", 2) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid", 3) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid", 4) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid", 5) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>'),
            (t +=
              '<a href="' +
              Utils.buildToolbarLink("display", "list", "grid") +
              '" title="' +
              f("grid", 6) +
              '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>')),
        t.replace(/{{class.productDisplayType}}/g, Class.productDisplayType)
      );
    });
  var u = ProductDisplayType.prototype.render;
  (ProductDisplayType.prototype.render = function () {
    if ((u.call(this), this.$element.length))
      if (
        (this.$element
          .find(this.selector.productDisplayTypeList)
          .removeClass("active"),
        this.$element
          .find(this.selector.productDisplayTypeGrid)
          .removeClass("active"),
        "list" == Utils.stripHtml(Globals.queryParams.display))
      )
        this.$element
          .find(this.selector.productDisplayTypeList)
          .addClass("active");
      else if ("grid" == Utils.stripHtml(Globals.queryParams.display))
        if (
          "view_as_type_list_grid_multi_col" !=
            boostPFSThemeConfig.custom.view_as_type ||
          Utils.isMobile()
        )
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .addClass("active");
        else {
          var t = boostPFSThemeConfig.custom.products_per_row;
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .each(function () {
              var e = jQ(this).parent(),
                i = jQ(".boost-pfs-filter-top-display-type")
                  .attr("class")
                  .split(" "),
                s = i[i.length - 1],
                a = s.split("-")[s.split("-").length - 1];
              if (
                e.hasClass("boost-pfs-filter-view-as-click") &&
                jQ(this).data("view") == s
              ) {
                if (
                  (jQ(this).addClass("active"),
                  jQ(".boost-pfs-filter-product-item").length > 0)
                ) {
                  for (
                    var o = jQ(".boost-pfs-filter-product-item")
                        .attr("class")
                        .split(" "),
                      l = "",
                      r = 0;
                    r < o.length;
                    r++
                  )
                    if (o[r].match(/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                      l = o[r];
                      break;
                    }
                  jQ(".boost-pfs-filter-product-item").removeClass(l),
                    jQ(".boost-pfs-filter-product-item").addClass(
                      "boost-pfs-filter-grid-width-" + a
                    );
                }
              } else e.hasClass("boost-pfs-filter-view-as-click") || jQ(this).data("view").split("-")[1] != t || jQ(this).addClass("active");
            });
        }
  }),
    (ProductLimit.prototype.compileTemplate = function () {
      var t = "";
      if (
        boostPFSThemeConfig.custom.show_limit &&
        boostPFSTemplate.hasOwnProperty("showLimitHtml")
      ) {
        var e = Settings.getSettingValue("general.showLimitList");
        if ("" != e) {
          var i = "",
            s = e.split(",");
          for (var a in sortingArr)
            i +=
              '<option value="' +
              s[a].trim() +
              '">' +
              s[a].trim() +
              "</option>";
          t = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, i);
        }
      }
      return t;
    }),
    (Breadcrumb.prototype.compileTemplate = function (t) {
      t || (t = this.collectionData);
      var e = "";
      if (boostPFSTemplate.hasOwnProperty("breadcrumbHtml"))
        if (void 0 !== t && t.hasOwnProperty("collection")) {
          var i = t.collection;
          void 0 !== this.collectionTags && null !== this.collectionTags
            ? ((e += boostPFSTemplate.breadcrumbItemLink
                .replace(/{{itemLink}}/g, "/collections/" + i.handle)
                .replace(/{{itemTitle}}/g, i.title)),
              (e += " {{breadcrumbDivider}} "),
              (e += boostPFSTemplate.breadcrumbItemSelected.replace(
                /{{itemTitle}}/g,
                this.collectionTags[0]
              )))
            : (e += boostPFSTemplate.breadcrumbItemSelected.replace(
                /{{itemTitle}}/g,
                i.title
              ));
        } else
          e += boostPFSTemplate.breadcrumbItemSelected.replace(
            /{{itemTitle}}/g,
            Settings.getSettingValue("label.defaultCollectionHeader")
          );
      return e;
    }),
    (ProductList.prototype.afterRender = function (t) {
      t || (t = this.data),
        window.SPR &&
          "function" == typeof window.SPR.initDomEls &&
          "function" == typeof window.SPR.loadBadges &&
          boostPFSThemeConfig.custom.show_product_review &&
          (window.SPR.initDomEls(), window.SPR.loadBadges()),
        document
          .querySelectorAll(".boost-pfs-filter-product-item-image")
          .forEach((t) => {
            const e = t.querySelector(".product-item-slider"),
              i = t.querySelector(
                '[data-component="product-item-slider-prev"]'
              ),
              s = t.querySelector(
                '[data-component="product-item-slider-next"]'
              );
            i &&
              i.addEventListener("click", () => {
                s.parentNode.querySelectorAll(".swiper-slide").forEach((r) => {
                  r.querySelector(
                    ".boost-pfs-filter-product-item-main-image"
                  ).src = r
                    .querySelector(".boost-pfs-filter-product-item-main-image")
                    .getAttribute("data-og");
                });
                a.slidePrev();
              }),
              s &&
                s.addEventListener("click", () => {
                  s.parentNode
                    .querySelectorAll(".swiper-slide")
                    .forEach((r) => {
                      r.querySelector(
                        ".boost-pfs-filter-product-item-main-image"
                      ).src = r
                        .querySelector(
                          ".boost-pfs-filter-product-item-main-image"
                        )
                        .getAttribute("data-og");
                    });
                  a.slideNext();
                });
          });
    }),
    (Filter.prototype.afterRender = function (t) {
      t || (t = this.data);
      var e,
        i,
        s =
          t.total_product +
          "<span> " +
          boostPFSThemeConfig.label.items_with_count_other +
          "</span>";
      if (
        (1 == t.total_product &&
          (s =
            t.total_product +
            "<span> " +
            boostPFSThemeConfig.label.items_with_count_one +
            "</span>"),
        0 == t.total_product
          ? jQ(".boost-pfs-filter-default-toolbar-inner").addClass(
              "boost-pfs-filter-toolbar-product-0"
            )
          : jQ(".boost-pfs-filter-default-toolbar-inner").removeClass(
              "boost-pfs-filter-toolbar-product-0"
            ),
        jQ(".boost-pfs-filter-total-product").html(s),
        jQ("body").find(".boost-pfs-filter-skeleton-button").remove(),
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
          !window.MSStream &&
          Utils.isMobile() &&
          jQ(".boost-pfs-filter-product-item")
            .find("a")
            .on("touchstart", function () {
              isScrolling = !1;
            })
            .on("touchmove", function () {
              isScrolling = !0;
            })
            .on("touchend", function () {
              isScrolling || (window.location = jQ(this).attr("href"));
            }),
        (function (t) {
          if (
            !Utils.isMobile() &&
            boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
            1 == boostPFSThemeConfig.custom.active_image_swap
          ) {
            var e = "",
              i = "",
              s = "",
              a = "",
              o = "";
            jQ(".boost-pfs-filter-product-item").each(function () {
              var t = jQ(this),
                l = t.find(".boost-pfs-filter-product-item-main-image");
              void 0 !== l.data("img-flip-src") &&
                "" != l.data("img-flip-src") &&
                ((i = l.data("img-flip-src")),
                (e = l.data("img-flip-srcset")),
                (s = l.attr("alt")),
                (a = l.data("widths")),
                (o =
                  '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"data-srcset="' +
                  e +
                  '" data-src="' +
                  i +
                  '" data-widths="[' +
                  a +
                  ']" data-sizes="auto" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="' +
                  s +
                  '" />'),
                t.find(".boost-pfs-filter-product-item-image-link").append(o));
            });
          }
        })(),
        "list" !== Utils.stripHtml(Globals.queryParams.display) &&
          setTimeout(function () {
            g();
          }, 700),
        jQ(window).resize(function () {
          "list" !== Utils.stripHtml(Globals.queryParams.display) &&
            setTimeout(function () {
              g();
            }, 700);
        }),
        "none" != boostPFSThemeConfig.custom.swatch_change_img &&
          ((e = boostPFSThemeConfig.custom.swatch_change_img),
          jQ(".boost-pfs-filter-item-swatch li span").each(function () {
            var t = jQ(this)
              .parents(".boost-pfs-filter-product-item-inner")
              .find(".boost-pfs-filter-product-item-main-image");
            "hover" == e &&
              jQ(this).hover(function () {
                var e = jQ(this).data("img");
                t.attr("srcset", e);
              }),
              "click" == e &&
                jQ(this).click(function () {
                  var e = jQ(this).data("img");
                  t.attr("srcset", e);
                }),
              jQ(this).focus(function () {
                if (jQ("body").hasClass("boost-pfs-ada")) {
                  var e = jQ(this).data("img");
                  t.attr("srcset", e);
                }
              });
          })),
        (i = jQ(Selector.products).find("[data-boost-image-loading-animation]"))
          .length && i.removeAttr("data-boost-image-loading-animation"),
        boostPFSThemeConfig.custom.hasOwnProperty("layout_type") &&
          "fullwidth" == boostPFSThemeConfig.custom.layout_type &&
          !Utils.isMobile() &&
          jQ("body").addClass("boost-pfs-filter-fullwidth-page"),
        document.addEventListener("scroll", function () {
          jQ(".boost-pfs-filter-tree-h.boost-pfs-filter-stick").length > 0 &&
            jQ(window).width() > 767 &&
            jQ(
              ".boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown"
            )
              .hide()
              .parent()
              .removeClass("boost-pfs-filter-sort-active");
        }),
        jQ(".site-nav__thumb-menu").length > 0 && Utils.isMobile())
      ) {
        var a = jQ(".site-nav__thumb-menu").height() + 40;
        jQ(".boost-pfs-filter-tree-mobile-button-stick-wrapper")
          .css("bottom", a)
          .addClass("boost-pfs-filter-sticky-bottom"),
          jQ(".boost-pfs-filter-mobile-style1").addClass(
            "boost-pfs-filter-mobile-style1-sticky-bottom"
          );
      }
    });
  var m = ProductDisplayType.prototype._onClickEvent;
  function g(t) {
    var e = -1,
      i = [],
      s = null;
    jQ(".boost-pfs-filter-product-item").each(function (t, a) {
      var o = jQ(a).offset().top;
      (s && s.offset().top === o) || ((s = jQ(a)), e++),
        i[e] || (i[e] = []),
        i[e].push(a);
    });
    for (var a = 0; a < i.length; a++) {
      for (var o = 0, l = (i[a].length, 0); l < i[a].length; l++) {
        var r = i[a][l],
          n = jQ(r).find(".boost-pfs-filter-product-bottom-inner").height();
        o = Math.max(o, n);
      }
      jQ(i[a])
        .find(".boost-pfs-filter-product-bottom-inner")
        .css({ "min-height": o });
    }
    var c = boostPFSFilterConfig.general.aspect_ratio;
    if ("false" != c) {
      var p = boostPFSFilterConfig.general.cropImagePossitionEqualHeight,
        d = jQ(".boost-pfs-filter-product-item").width();
      if ("false" != c && "auto" != c) {
        var f = 0;
        if (
          ((d = jQ(".boost-pfs-filter-product-item").width()),
          "false" != c && "auto" != c && "other" != c)
        )
          var u = boostPFSThemeConfig.custom.aspect_ratio;
        else u = "";
        var m = boostPFSThemeConfig.custom.aspect_ratio_other;
        if ("" == m && "" == u) return null;
        "other" != c
          ? ((u = u.split(":")),
            (f = d * (u = parseInt(u[1]) / parseInt(u[0]))))
          : "" != m &&
            "other" == c &&
            ((m = m.split(":")),
            (f = d * (m = parseInt(m[1]) / parseInt(m[0])))),
          jQ(".boost-pfs-filter-product-item-image-link")
            .css({ "padding-top": f + "px" })
            .addClass("boost-pfs-filter-crop-image-position-" + p);
      }
    }
  }
  function b() {
    jQ(".boost-pfs-filter-option-item").on("click", function () {
      var t = jQ(this).parents(".boost-pfs-filter-option");
      t.hasClass("shownumber") && t.removeClass("shownumber");
    }),
      jQ("li.boost-pfs-filter-option-multi-level-item button").on(
        "click",
        function () {
          jQ("li.boost-pfs-filter-option-multi-level-item").removeClass(
            "sublayer-open"
          ),
            jQ(this)
              .parents(".boost-pfs-filter-option-first-level-item")
              .addClass("sublayer-open");
        }
      );
  }
  function h() {
    var t = jQ(".boost-pfs-filter-refine-by-items").html();
    null == t
      ? (jQ(".applied-filter").removeClass("show-clear"),
        jQ("#applied-filter").empty(),
        jQ(".filter-drawer span").html("Filter"))
      : (jQ(".applied-filter").addClass("show-clear"),
        jQ("#applied-filter").html(t),
        jQ(".clear-all").html(
          "Reset Filters (" +
            jQ(".applied-filter .refine-by-item button").length +
            ")"
        ),
        jQ(".boost-pfs-filter-clear-all").html(
          "Reset Filters (" +
            jQ(".applied-filter .refine-by-item button").length +
            ")"
        ),
        jQ(".filter-drawer span").html(
          "Filter <span>(" +
            jQ(".applied-filter .refine-by-item button").length +
            ")</span>"
        ),
        jQ(".boost-pfs-filter-product-item").removeClass("promo"));
  }
  function y() {
    jQ(".applied-filter .refine-by-item button").on("click", function () {
      var t = jQ(this).attr("aria-label");
      jQ(".boost-pfs-filter-refine-by-items .refine-by-item").each(function () {
        var e = jQ(this).find("button").attr("aria-label");
        e == t &&
          jQ(this)
            .find('button[aria-label="' + e + '"]')
            .trigger("click");
      });
    });
  }
  (ProductDisplayType.prototype._onClickEvent = function (t) {
    FilterApi.setParam("page", 1);
    if (
      (m.call(this, t),
      "view_as_type_list_grid_multi_col" ==
        boostPFSThemeConfig.custom.view_as_type && !Utils.isMobile())
    ) {
      jQ(".boost-pfs-filter-top-display-type").addClass(
        "boost-pfs-filter-view-as-click"
      );
      var e = jQ(t.target).data("view");
      (jQ(".boost-pfs-filter-top-display-type")[0].className = jQ(
        ".boost-pfs-filter-top-display-type"
      )[0].className.replace(/(^|\s)grid-\S+/g, "")),
        jQ(".boost-pfs-filter-top-display-type").addClass(e);
    }
  }),
    (ProductListPlaceholder.prototype.render = function () {
      var t =
          this.settings.productsPerRow ||
          this.settings.placeholderProductPerRow,
        e = this.compileTemplate();
      this.$element = [];
      for (var i = 0; i < t; i++) this.$element.push(jQ(e));
      this.isFetchedProductData ? this.setHide() : this.setShow();
    }),
    (ProductListPlaceholder.prototype.compileTemplateExtra = function () {
      var t = boostPFSTemplate.productListPlaceholderHtml,
        e = parseFloat(this.settings.placeholderImageRatio),
        i = e > 0 ? e : 1.4;
      return t
        .replace(
          /{{class.filterProductSkeleton}}/g,
          Class.filterProductSkeleton
        )
        .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
        .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
        .replace(/{{paddingTop}}/g, 100 * i);
    }),
    (Array.prototype.insert = function (t, e) {}),
    jQ(document).ready(function () {
      if (jQ(".mm-fixed-top").length > 0) {
        var t = jQ(".mm-fixed-top").height();
        jQ(".boost-pfs-filter-collection-header-wrapper").css("margin-top", t);
      }
    }),
    (FilterResult.prototype.afterRender = function () {
      this.data,
        setTimeout(function () {
          jQ(document).on(
            "click",
            ".boost-pfs-filter-option-title",
            function () {
              jQ(".boost-pfs-filter-option-title").removeClass("active"),
                jQ(this).addClass("active");
            }
          ),
            jQ(".boost-pfs-filter-option-item.selected").hasClass("selected") &&
              jQ(".boost-pfs-filter-option-item.selected")
                .parents(".boost-pfs-filter-option-list")
                .addClass("shownumber"),
            h(),
            b(),
            y();
        }, 300);
    }),
    BoostPFS.jQ(window).on("load", function () {
      var t = jQ(".boost-pfs-filter-sort-item-active").html();
      setTimeout(function () {
        jQ(document).on(
          "click",
          ".custom-select .select-items div",
          function () {
            var t = jQ(this).data("value");
            jQ(".boost-pfs-filter-filter-dropdown li").each(function () {
              var e = jQ(this).children().data("sort");
              t == e && jQ(this).children().trigger("click");
            });
          }
        );
      }, 300),
        jQ(window).width() > 767 &&
          jQ(".custom-select .select-selected").html(t),
        jQ(".boost-pfs-filter-option-item.selected").hasClass("selected") &&
          (jQ(".boost-pfs-filter-option-item.selected")
            .parents(".boost-pfs-filter-option-list")
            .addClass("shownumber"),
          jQ(".boost-pfs-filter-option-item.selected")
            .parents(".boost-pfs-filter-option-content")
            .removeClass("toggled")
            .show(),
          jQ(".boost-pfs-filter-option-item.selected")
            .parents(".boost-pfs-filter-option")
            .removeClass("boost-pfs-filter-option-collapsed")),
        h(),
        b();
    }),
    jQ(document).on("click", ".clear-all", function () {
      jQ(".boost-pfs-filter-clear-all").trigger("click");
    }),
    jQ(window).on("load", function () {
      y();
    });

  // Only send Weglot request if the current language is different from English
  function isWeglotActive() {
    if (!window.Weglot || !window.Weglot.initialized) {
      return false;
    } else {
      var currentLang = Weglot.getCurrentLang();

      // Change 'en' to suitable with original language of the store
      return currentLang !== "en";
    }
  }

  InstantSearchApi.beforeCallAsync = function (
    searchTerm,
    callInstantSearchApi
  ) {
    // Then use it in our API

    if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
      Weglot.search(searchTerm, function (englishTerm) {
        Globals.instantSearchQueryParams["q"] = englishTerm;

        callInstantSearchApi();
      });
    } else {
      callInstantSearchApi();
    }
  };
})();
